import Control from '@/Controls/Control';
import ComponentManager from '@/Management/ComponentManager';
import EnhancedTabGroupBoxViewModel from '@/ViewModels/Controls/EnhancedTabGroupBoxViewModel';

export default class EnhancedTabGroupBox extends Control {

    private jQueryControl: JQuery;
    private content: JQuery;

    public constructor(private viewModel: EnhancedTabGroupBoxViewModel, private element?: JQuery) {
        super(viewModel, element);
    }

    public getControl(): JQuery {
        if (this.jQueryControl != null) {
            return this.jQueryControl;
        }

        this.jQueryControl = this.element || $('<div></div>');

        this.defineSubscription(this.viewModel._refreshTrigger, this.drawTabs.bind(this));

        this.applyBindings(this.jQueryControl, {
            controlName: 'tabgroupbox',
            tabBox: {},
            visible: this.viewModel.isVisible,
            loader: this.viewModel.isBusy,
            controlIdent: this.identifier
        });

        return this.jQueryControl;
    }

    private drawTabs(): void {
        let tabTitleWrapper = this.jQueryControl.find('>ul');
        let tabTitle = tabTitleWrapper.find('li');
        let tabs = this.jQueryControl.find('> div');
        let tabsWrapper = $('<div>');

        tabTitle.each((index: number, element: HTMLElement) => {
            let $el = $(element);
            let link = $el.find('a');
            // Click-Events entfernen, falls bereits gesetzt
            $el.off('click.' + this.identifier);
            this.addEventHandler('click', link, () => {
                this.viewModel.selectedIndex(index);
                // Damit die Kinder neu gezeichnet werden (beim Grid gibt es bspw. sonst Fehler bei der Darstellung)
                $(window).trigger('resize');
            });

            this.applyBindings($el, {
                states: this.definePureComputed({
                    read: () => {
                        let states = [];

                        if (this.viewModel.selectedIndex() === index) {
                            states.push('active');
                        }

                        return states;
                    }
                })
            });
        });

        tabs.each((index: number, element: HTMLElement) => {
            let $el = $(element);
            this.applyBindings($el, {
                visible: this.definePureComputed(() => {
                    return this.viewModel.selectedIndex() == index;
                })
            });
            tabsWrapper.append($el);
        });

        this.jQueryControl.append(tabsWrapper);
        this.addClasses();
    }

    private addClasses() {
        this.jQueryControl.addClass('c-tabstrip2');
        this.jQueryControl.find('> div').addClass('c-tabs-wrapper');

        let list = this.jQueryControl.find('> ul');
        list.addClass('c-list-wrapper');
        list.find('li').addClass('c-title');
        list.find('a').addClass('c-link');
        list.find('span').addClass('c-label');
    }
}

ComponentManager.setControl('EnhancedTabGroupBox', EnhancedTabGroupBox, 'RADPresentation.HTMLClient.DefaultViewExtensions');